// GAVION custom pipeline: Settings → Pipeline (admins).
export const pipelineEn = {
  title: "Pipeline",
  intro:
    "The deal stages, in board order. Won and Lost always stay last. New lead, Qualified, Won and Lost cannot be deleted, but can be renamed and recoloured. A renamed stage shows its new name in French and English.",
  open_stages: "Open stages",
  closed_stages: "Closing stages",
  label: "Stage name",
  color: "Colour",
  probability: "Probability (%)",
  drag: "Drag to move %{label}",
  move_up: "Move %{label} up",
  move_down: "Move %{label} down",
  delete: "Delete %{label}",
  add: "Add a stage",
  manage: "Manage stages",
  new_stage: "New stage",
  save: "Save",
  saved: "Pipeline saved",
  loading: "Loading the pipeline…",
  deleted: "Stage deleted",
  deleted_moved:
    "Stage deleted: %{smart_count} deal moved |||| Stage deleted: %{smart_count} deals moved",
  move_dialog: {
    title: "Delete the stage “%{label}”",
    body: "%{smart_count} deal is at this stage. Move it to: |||| %{smart_count} deals are at this stage. Move them to:",
    target: "Target stage",
    note: "The move triggers no automation and no webhook. Won and Lost are not offered: they need an amount or a loss reason.",
    confirm: "Move and delete",
    cancel: "Cancel",
  },
  errors: {
    forbidden: "Only an admin can change the pipeline.",
    invalid_stages: "The stage list is invalid. Reload the page.",
    invalid_stage_value: "Invalid stage value: %{detail}.",
    duplicate_stage: "Two stages have the same value: %{detail}.",
    invalid_stage_label: "Every stage needs a name (60 characters at most).",
    invalid_stage_color: "Invalid colour (#rrggbb).",
    invalid_stage_probability:
      "The probability must be a number between 0 and 100%.",
    missing_system_stage: "Required stages missing: %{detail}.",
    stage_in_use:
      "Deals are still at these stages: %{detail}. Delete them one by one to choose where their deals go.",
    stage_in_rules:
      "This stage is used by active automations: %{detail}. Edit or turn them off first.",
    system_stage: "This stage cannot be deleted.",
    unknown_stage: "This stage no longer exists. Reload the page.",
    invalid_move_target: "Choose an open stage as the target.",
    unknown: "Saving failed. Try again.",
    load_failed: "The pipeline could not be read. Reload the page.",
  },
  upstream_moved: "Deal stages are managed in Settings → Pipeline.",
};
